<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editResourceCategory') }}</h1>
      <div class="form-container">
        <ResourceCategoryForm :data="relations.instance" @save="save"></ResourceCategoryForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {mapState} from 'vuex'
  import ResourceCategoryForm from "@/components/ResourceCategoryForm"

  export default {
    components: {
      ResourceCategoryForm,
      DashboardLayout,
    },
    methods: {
      save(payload) {
        this.$store.dispatch('Moderator/update', {actionType: 'resource_categories', payload}).then(() =>
          this.$router.push({ name: 'resourceCategories'}))
      }
    },
    mounted() {
      this.$store.dispatch('Moderator/getRelations', {actionType: 'resource_categories', id: this.$route.params.id})
    },
    computed: {
      ...mapState('Moderator', ['relations']),
      breadcrumbs() {
        return [
          {name: 'resourceCategories', path: 'resourceCategories'},
          {name: 'editResourceCategory'}
        ]
      }
    }
  }
</script>